import { render, staticRenderFns } from "./AddNewFeed.vue?vue&type=template&id=e2c21346&"
import script from "./AddNewFeed.vue?vue&type=script&lang=js&"
export * from "./AddNewFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports